
import "../assets/css/privacy/privacy.css";
import TopNav from '../components/topNav';
import Header from '../components/header';
import Footer from '../components/footer';

const Privacy = () => {
    return (
        <div className='container privacy'>
             <TopNav />
      <Header />
                <div className="default-container">
                    <h1 className="title">Privacy Policy</h1>
                    <p>Please read the privacy policy carefully</p>
                </div>
                <div className="privacy default-container white-background">
                    <h1>Privacy</h1>
                    <div>
                        This privacy policy discloses the privacy practices for https://www.cohesivestaffing.com. This privacy policy applies
                        solely to information collected by this website. It will notify you of the following: <br />
                            <span>1. </span>What personally identifiable information is collected from you through the website, how it is
                            used and with whom it may be shared. <br />
                                <span>2.</span> What choices are available to you regarding the use of your data. <br />
                                    <span>3.</span> The security procedures in place to protect the misuse of your information. <br />
                                        <span>4.</span> How you can correct any inaccuracies in the information.
                                        Information Collection, Use, and Sharing
                                        We are the sole owners of the information collected on this site. We only have access to/collect information
                                        that you voluntarily give us via email or other direct contact from you. We will not sell or rent this
                                        information to anyone.
                                        We will use your information to respond to you, regarding the reason you contacted us. We will not share your
                                        information with any third party outside of our organization, other than as necessary to fulfill your request.
                                        Unless you ask us not to, we may contact you via email in the future to tell you about specials, new products or
                                        services, or changes to this privacy policy.

                                    </div>
                                </div>
                                <div className="information-control default-container blue-background">
                                    <h1>Your Access to and Control Over Information</h1>
                                    <div>
                                        You may opt out of any future contacts from us at any time. You can do the following at any time by contacting
                                        us via the email address or phone number given on our website:
                                        <ul>
                                            <li>See what data we have about you, if any.</li>
                                            <li>Change/correct any data we have about you.</li>
                                            <li> Have us delete any data we have about you.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="security default-container white-background">
                                    <h1>
                                        Security</h1>
                                    <div>
                                        <p>We take precautions to protect your information. When you submit sensitive information via the website, your
                                            information is protected both online and offline.
                                            Wherever we collect sensitive information (such as credit card data), that information is encrypted and
                                            transmitted to us in a secure way. You can verify this by looking for a closed lock icon at the bottom of
                                            your web browser, or looking for "https" at the beginning of the address of the web page. While we use
                                            encryption to protect sensitive information transmitted online, we also protect your information offline.
                                            Only employees who need the information to perform a specific job (for example, billing or customer service)
                                            are granted access to personally identifiable information. The computers/servers in which we store
                                            personally identifiable information are kept in a secure environment.</p>
                                    </div>
                                </div>
                                <div className="cookies default-container blue-background">
                                    <h1>Cookies</h1>
                                    <div>
                                        <p>We use "cookies" on this site. A cookie is a piece of data stored on a site visitor's hard drive to help us
                                            improve your access to our site and identify repeat visitors to our site. For instance, when we use a
                                            cookie to identify you, you would not have to log in a password more than once, thereby saving time while on
                                            our site. Cookies can also enable us to track and target the interests of our users to enhance the
                                            experience on our site. Usage of a cookie is in no way linked to any personally identifiable information on
                                            our site.
                                            Some of our business partners may use cookies on our site (for example, advertisers). However, we have no
                                            access to or control over these cookies.</p>
                                    </div>
                                </div>
                                <div className="links default-container white-background">
                                    <h1>Links</h1>
                                    <div>
                                        <p>
                                            This website contains links to other sites. Please be aware that we are not responsible for the content or
                                            privacy practices of such other sites. We encourage our users to be aware when they leave our site and to
                                            read the privacy statements of any other site that collects personally identifiable information.
                                        </p>
                                    </div>
                                </div>
                                <div className="surveys default-container blue-background">
                                    <h1>
                                        Surveys & Contests</h1>
                                    <div>
                                        <p>
                                            From time-to-time our site requests information via surveys or contests. Participation in these surveys or
                                            contests is completely voluntary and you may choose whether to participate and therefore disclose
                                            this information. Information requested may include contact information (such as name and address), and
                                            demographic information (such as zip code, age level). Contact information will be used to notify the
                                            winners and award prizes. Survey information will be used for purposes of monitoring or improving the use
                                            and satisfaction of this site.
                                        </p>
                                    </div>
                                </div>
                                <div className="update default-container white-background">
                                    <h1>
                                        Updates</h1>
                                    <div>
                                        <p>Our Privacy Policy may change from time to time and all updates will be posted on this page.
                                            If you feel that we are not abiding by this privacy policy, you should contact us immediately via telephone
                                            at 405-367-4422. or via email info@staffingok.com</p>
                                    </div>
                                </div>
                               <Footer />
                        </div>
                    )
                }

                export default Privacy